export { default } from './SVGIcons';
